import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('repository');

export default {
  setApiBaseUrl: actionCreator<string>('SET_API_BASE_URL'),
  initAuthorizedApi: actionCreator<string>('INIT_AUTHORIZED_API'),
  initApi: actionCreator<void>('INIT_API'),
};